jQuery(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >=100) {
        jQuery("body").addClass("lang-active");
    } else {
        jQuery("body").removeClass("lang-active");
    }
});
jQuery(document).ready(function() {
              var owl = jQuery('.category-slider');
              owl.owlCarousel({
                margin: 10,
                nav: true,
                loop: false,
                dots:false,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 2
                  },
                  1000: {
                    items: 4
                  }
                }
              })
              var owl = jQuery('.blog-slider');
              owl.owlCarousel({
                margin: 20,
                nav: true,
                loop: false,
                dots:false,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 2
                  },
                  1000: {
                    items: 3
                  }
                }
              })
               var owl = jQuery('.featured-items-slider');
              owl.owlCarousel({
                margin: 20,
                nav: true,
                loop: false,
                dots:false,
                autoHeight: true,
                items: 1
              })
            })
 
 jQuery(function(){

  //Scroll event
  jQuery(window).scroll(function(){
    var scrolled = jQuery(window).scrollTop();
    if (scrolled > 200) $('.go-top').fadeIn('slow');
    if (scrolled < 200) $('.go-top').fadeOut('slow');
  });
  
  //Click event
  jQuery('.go-top').click(function () {
    jQuery("html, body").animate({ scrollTop: "0" },  500);
  });

});
jQuery(document).ready(function(){
	jQuery('.nav-item-custom-tab').click(function(){
		// reset active class
		jQuery('.nav-item-custom-tab').removeClass("active");
		// add active class to selected
		jQuery(this).addClass("active");
		// return needed to make function work
		return false;
	});
	
	
	jQuery(function() {
		// create an empty variable
		var selectedClass = "";
		// call function when item is clicked
		jQuery(".nav-item-custom-tab").click(function(){
			// assigns class to selected item
			selectedClass = $(this).attr("data-rel");
			// fades out all brands-filter items
			jQuery(".brands-filter .brands-filter-content").fadeOut(0);
			// fades in selected category
			jQuery(".brands-filter .brands-filter-content." + selectedClass).fadeIn(0);
		});
	});
  
}); // document ready


  jQuery(document).ready(function(){
jQuery(function(jQuery) {
  let url = window.location.href;
  jQuery('.leran-tags-filetr ul li a').each(function() {
    if (this.href === url) {
      jQuery(this).closest('li').addClass('active');
    }
  });
   jQuery(".ar-load-row").slice(0, 6).show();
  jQuery("#loadMore").on("click", function(e){
    e.preventDefault();
    jQuery(".ar-load-row:hidden").slice(0, 6).slideDown();
    if(jQuery(".ar-load-row:hidden").length == 0) {
      jQuery("#loadMore").text("No More Posts").addClass("noContent");
    }
  });
  
   jQuery(".h-search-icon").click(function(){
    jQuery(".head-custom-search-bar").addClass("active-search");
  });
  jQuery(".hide-h-searh-btn").click(function(){
    jQuery(".head-custom-search-bar").removeClass("active-search");
  });
  
  jQuery(".categories-btn").click(function(){
    jQuery(".leran-tags-filetr").toggleClass("filter-active");
  });

});
        
  
            });

jQuery(document).ready(function(){
if (jQuery(window).width() < 991) {
jQuery(".brand-list-ul").click(function() {
  var is_open = jQuery(this).hasClass("open");
  if (is_open) {
    jQuery(this).removeClass("open");
  } else {
    jQuery(this).addClass("open");
  }
});

jQuery(".brand-list-ul li").click(function() {

  var selected_value = jQuery(this).html();
  var first_li = jQuery(".brand-list .nav-pills li:first-child").html();

  jQuery(".brand-list-ul li:first-child").html(selected_value);
  jQuery(this).html(first_li);

});

jQuery(document).mouseup(function(event) {

  var target = event.target;
  var select = jQuery(".brand-list-ul");

  if (!select.is(target) && select.has(target).length === 0) {
    select.removeClass("open");
  }

});
}
});
jQuery(document).ready(function($) {
              $('.annonuncement-slider').owlCarousel({
                items: 1,
                autoplay: true,
                autoplayTimeout:4000,
                loop: true,
                margin: 10,
				nav:false,
				dots:false,
              });

            });

jQuery(document).ready(function(){
  jQuery(".h-search-icon").click(function(){
    jQuery(".weglot-container").addClass("hide-lang");
  });
  jQuery(".hide-h-searh-btn").click(function(){
    jQuery(".weglot-container").removeClass("hide-lang");
  });
});

(function () {
  var focusableSelector = "a, button, input, select, textarea, [tabindex]";

  function syncProductCard(card) {
    var hidden = card.getAttribute("aria-hidden") === "true";
    var controls = card.querySelectorAll(focusableSelector);

    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];

      if (hidden) {
        if (!control.hasAttribute("data-a11y-tabindex")) {
          var current = control.getAttribute("tabindex");
          control.setAttribute("data-a11y-tabindex", current == null ? "" : current);
        }
        if (control.getAttribute("tabindex") !== "-1") {
          control.setAttribute("tabindex", "-1");
        }
      } else if (control.hasAttribute("data-a11y-tabindex")) {
        var original = control.getAttribute("data-a11y-tabindex");
        if (original === "") {
          control.removeAttribute("tabindex");
        } else {
          control.setAttribute("tabindex", original);
        }
        control.removeAttribute("data-a11y-tabindex");
      }
    }
  }

  function syncProductCards(root) {
    var cards = (root || document).querySelectorAll(".pro-card-grid-item, .productgrid--item");
    for (var i = 0; i < cards.length; i++) {
      syncProductCard(cards[i]);
    }
  }

  function start() {
    syncProductCards(document);

    if (!document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target.classList && (target.classList.contains("pro-card-grid-item") || target.classList.contains("productgrid--item"))) {
          syncProductCard(target);
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();

(function () {
  function removePriceNames(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches("span.rc-option__price[aria-label]")) {
      root.removeAttribute("aria-label");
    }
    var prices = root.querySelectorAll("span.rc-option__price[aria-label]");
    for (var i = 0; i < prices.length; i++) {
      prices[i].removeAttribute("aria-label");
    }
  }

  function start() {
    removePriceNames(document);
    if (!document.body) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === "attributes" && mutation.target.matches && mutation.target.matches("span.rc-option__price")) {
          mutation.target.removeAttribute("aria-label");
        }
        if (mutation.type === "childList") {
          for (var n = 0; n < mutation.addedNodes.length; n++) {
            var node = mutation.addedNodes[n];
            if (node.nodeType === 1) removePriceNames(node);
          }
        }
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["aria-label"],
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();


